module.exports = __webpack_public_path__ + "img/residentList2.0e93b55e.png";